import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { DatePickerModule } from 'primeng/datepicker';

export interface DatepickerProps extends FormlyFieldProps {
  dateFormat?: string;
  hourFormat?: string;
  showTime?: boolean;
  showIcon?: boolean;
  showButtonBar?: boolean;
  showOtherMonths?: boolean;
  selectOtherMonths?: boolean;
  selectionMode?: 'single' | 'multiple' | 'range';
  numberOfMonths?: number;
  inline?: boolean;
  readonlyInput?: boolean;
  touchUI?: boolean;
  yearRange?: string;
  minDate?: Date;
  maxDate?: Date;
  view?: 'date' | 'month' | 'year';
  firstDayOfWeek?: number;
  showClear?: boolean;
  dataType?: 'string' | 'date';
}

export interface FormlyDatepickerFieldConfig
  extends FormlyFieldConfig<DatepickerProps> {
  type: 'datepicker' | Type<FormlyDatepickerTypeComponent>;
}

@Component({
  selector: 'kon-datepicker-type',
  imports: [DatePickerModule, ReactiveFormsModule],
  template: ` <p-datepicker
    [view]="props.view ?? 'date'"
    [dateFormat]="props.dateFormat ?? 'dd.mm.yy'"
    [dataType]="props.dataType ?? 'date'"
    [hourFormat]="props.hourFormat ?? '24'"
    [showTime]="props.showTime ?? false"
    [showIcon]="props.showIcon"
    [showButtonBar]="
      props.showButtonBar !== undefined ? props.showButtonBar : true
    "
    [showOtherMonths]="props.showOtherMonths ?? false"
    [selectOtherMonths]="props.selectOtherMonths"
    [selectionMode]="props.selectionMode ?? 'single'"
    [numberOfMonths]="props.numberOfMonths ?? 1"
    [inline]="props.inline ?? false"
    [readonlyInput]="props.readonlyInput"
    [touchUI]="props.touchUI"
    [showOtherMonths]="props.showOtherMonths"
    [placeholder]="props.placeholder"
    [formControl]="formControl"
    [showClear]="
      props.showClear !== undefined ? props.showClear : !props.required
    "
    [minDate]="props.minDate"
    [maxDate]="props.maxDate"
    (onSelect)="props.change?.(field, $event)"
    (onClear)="props.change?.(field, null)"
    [firstDayOfWeek]="props.firstDayOfWeek ?? 1"
    appendTo="body"
  >
  </p-datepicker>`,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDatepickerTypeComponent extends FieldType<
  FieldTypeConfig<DatepickerProps>
> {}
